import React from "react";
import PropTypes from "prop-types";

import OkSelect from "shared/components/oknf/OkSelect";

import {
	PRODUCT_TYPES,
} from "shared/payment/constants";

import "./ProductSwitcher.scss";

const ProductSwitcher = ({
	selectedProduct,
	productChoices,
	onSwitchProduct,
}) => {
	if (
		!productChoices.length ||
		selectedProduct.productType !== PRODUCT_TYPES.SUBSCRIPTION
	) {
		return null;
	}

	return (
		<div className="oknf oknf--gray payment-purchase-switcher">
			<OkSelect
				options={productChoices.map(({ subPeriod, productid, formattedInitialUnitPrice }) => ({
					name: `
						${formattedInitialUnitPrice}
						/ month -
						${subPeriod} ${subPeriod === 1 ? "month" : "months"}
					`,
					value: productid,
				}))}
				onChange={(ev) => {
					const productid = ev.target.value;
					const product = productChoices.reduce((memo, p) => {
						if (p.productid === productid) {
							return p;
						}

						return memo;
					}, null);

					onSwitchProduct(product);
				}}
				value={selectedProduct.productid}
			/>
		</div>
	);
};

ProductSwitcher.propTypes = {
	productChoices: PropTypes.array.isRequired,
	selectedProduct: PropTypes.object.isRequired,
	onSwitchProduct: PropTypes.func.isRequired,
};

export default ProductSwitcher;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ProductSwitcher.jsx